import { Card, SkeletonItem, Text } from '@capsicum/common-web';
import styled, { css } from 'styled-components';

export const NftCardWrapper = styled(Card)<{ $interactive: boolean; $size: 'default' | 'small' }>`
	display: flex;
	position: relative;
	width: 100%;
	height: 227px;

	${({ $size }) =>
		$size === 'small' &&
		css`
			height: 115px;
			min-height: 115px;
			max-width: 100px;
			min-width: 100px;
		`};

	${({ $interactive }) =>
		!$interactive &&
		css`
			cursor: default;
			pointer-events: none;
		`};
`;

export const NftCardWrapperContent = styled(Card.Content)<{ $size: 'default' | 'small' }>`
	${({ $size }) =>
		$size === 'small' &&
		css`
			padding: ${({ theme }) => theme.spacings.xxsmall};
		`};
`;

export const NftCardWrapperTitle = styled(Card.Title)<{ $size: 'default' | 'small' }>`
	${({ $size }) =>
		$size === 'small' &&
		css`
			${({ theme }) => theme.fonts.text.text4};
		`};
`;

export const SkeletonWrapper = styled.div`
	min-height: 214px;
	min-width: 160px;
	max-width: 358px;
	${({ theme }) => theme.border.radius.medium};
	display: flex;
	flex-direction: column;
	background-color: ${({ theme }) => theme.colors.backgrounds.main.container};
`;

export const IconWrapper = styled.div<{ $size: 'default' | 'small' }>`
	position: absolute;
	left: ${({ theme }) => theme.spacings.small};
	top: ${({ theme }) => theme.spacings.small};

	${({ $size }) =>
		$size === 'small' &&
		css`
			left: ${({ theme }) => theme.spacings.xxsmall};
			top: ${({ theme }) => theme.spacings.xxsmall};
		`};
`;

export const MediaWrapper = styled(Card.Media)<{
	$backgroundImage: string;
	$size: 'default' | 'small';
}>`
	background: ${({ $backgroundImage }) => `url(${$backgroundImage})`};
	background-size: cover;
	background-position: center center;

	${({ theme }) => theme.border.radius.mediumTop};

	display: flex;
	align-items: center;
	justify-content: center;

	${({ $size }) =>
		$size === 'small' &&
		css`
			height: 80px;
		`};
`;

export const NftCardMediaSkeleton = styled(SkeletonItem)`
	${({ theme }) => theme.border.radius.mediumTop};
	width: 100%;
	height: 160px;
	/*
     * There is a little margin caused by 3rd party skeleton item that shows a little white line above the skeleton.
     * This is a workaround to fix that.
    */
	transform: translateY(-2px);
`;

export const NftWrapper = styled.div<{ $backgroundImage: string; $size: 'default' | 'small' }>`
	background: url(${({ $backgroundImage }) => $backgroundImage});
	background-size: cover;
	background-position: center center;

	width: 90px;
	height: 142px;
	${({ $size }) =>
		$size === 'small' &&
		css`
			width: 45px;
			height: 70px;
			${({ theme }) => theme.border.radius.small};
		`};
`;

export const TextWithEllipsis = styled(Text)`
	padding: 0;
	margin: 0;
	width: 100%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;

	font-size: inherit;
	font-family: inherit;
	letter-spacing: inherit;
	line-height: inherit;
`;

export const LockedOverlay = styled.div`
	position: absolute;
	overflow: hidden;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;

	${({ theme }) => theme.border.radius.medium};
	/* TODO: Change background to a theme color when designers provide it */
	background-color: rgba(0, 33, 55, 0.8);
	z-index: 2;
`;

export const LockedTimeWrapper = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: ${({ theme }) => theme.spacings.small};
	row-gap: ${({ theme }) => theme.spacings.xxxsmall};
`;

export const LockedTimeLabel = styled(Text)`
	color: ${({ theme }) => theme.colors.white};
`;

export const LockedTimePill = styled.div`
	${({ theme }) => theme.border.radius.circle};
	background-color: rgb(0, 33, 55);
	display: flex;
	justify-content: center;
	align-items: center;
	padding: ${({ theme }) => `0px ${theme.spacings.xxsmall}`};
`;

export const LockedTimeText = styled(Text)`
	color: ${({ theme }) => theme.colors.white};
`;
